import React from 'react';

import { InputSwitch } from 'primereact/inputswitch';
import { RadioButton } from 'primereact/radiobutton';

import ImageComponent from 'shared/ImageComponent';
import { useHistory } from 'react-router-dom';
import { getTenantIdFromLS } from 'utils/localStorageUtils';
import { handleRedirection } from 'utils/utils';
import { generateFullName } from 'utils/generateFullNameUtils';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function AttendeesPreview(props) {
  const { selectedGroups, selectedFirmUsers, selectedContacts, isClientCalendar } = props;
  const tenantId = getTenantIdFromLS();
  const history = useHistory();
  const dataPreview = (data, type) => {
    const renderNameColumn = (item) => {
      switch (type) {
        case 'groups':
          return (
            <>
              {isClientCalendar ? (
                <div className="d-flex text-primary-dark text-decoration-none cursor-pointer">
                  <ImageComponent
                    filePath={`${tenantId}/${item?.client_cognito_username}/profile_image`}
                    fileName={item.group_name}
                    fileSize="small.jpg"
                  />
                  <div className="mx-2 align-items-center d-flex">{item.group_name}</div>
                </div>
              ) : (
                <Link
                  className="text-primary-dark pointer  align-items-center d-flex text-decoration-none d-flex bg-white"
                  to={'/settings/groups'}
                >
                  <ImageComponent
                    filePath={`${tenantId}/${item?.client_cognito_username}/profile_image`}
                    fileName={item.group_name}
                    fileSize="small.jpg"
                  />
                  <div className="text-primary-dark pointer align-items-center d-flex text-decoration-none mx-2">{item.group_name}</div>
                </Link>
              )}
            </>
          );
        case 'firm_users':
          return (
            <>
              {isClientCalendar ? (
                <div className="d-flex redirection-link-no-text-transform cursor-pointer">
                  <ImageComponent filePath={item?.profile_image} fileName={generateFullName(item)} fileSize="small.jpg" />
                  <div className="mx-2 align-items-center d-flex">{generateFullName(item) || item?.name}</div>
                </div>
              ) : (
                <Link
                  className="text-primary-dark pointer  align-items-center d-flex text-decoration-none d-flex bg-white"
                  to={item?.firm_user_id ? `/settings/team-management/${item.firm_user_id}` : '/settings/team-management'}
                >
                  <ImageComponent filePath={item?.profile_image} fileName={generateFullName(item)} fileSize="small.jpg" />
                  <div className="text-primary-dark pointer align-items-center d-flex text-decoration-none mx-2">
                    {generateFullName(item) || item?.name}
                  </div>
                </Link>
              )}
            </>
          );
        default:
          return (
            <>
              {isClientCalendar ? (
                <div className="d-flex redirection-link-no-text-transform cursor-pointer">
                  <ImageComponent filePath={item?.profile_image} fileName={generateFullName(item)} fileSize="small.jpg" />
                  <div className="mx-2 align-items-center d-flex">{generateFullName(item)}</div>
                </div>
              ) : (
                <Link
                  className="text-primary-dark pointer  align-items-center d-flex text-decoration-none d-flex bg-white"
                  to={item?.contact_id ? `/contacts/${item.contact_id}` : '/contacts'}
                >
                  <ImageComponent filePath={item?.profile_image} fileName={generateFullName(item)} fileSize="small.jpg" />
                  <div className="text-primary-dark pointer align-items-center d-flex text-decoration-none mx-2">
                    {generateFullName(item)}
                  </div>
                </Link>
              )}
            </>
          );
      }
    };
    return data.map((item, id) => {
      return (
        <tbody key={id}>
          <td className="attendee-names">{renderNameColumn(item)}</td>
          <td className="text-center">
            <div>
              <RadioButton
                inputId="required"
                name={`is_attendance_required`}
                value="required"
                checked={item.is_attendance_required === 'required'}
                className="disabledCursor"
                disabled={true}
              />
            </div>
          </td>
          <td className="text-center">
            <div className="p-field-radiobutton">
              <RadioButton
                inputId="optional"
                name="gender"
                value="optional"
                checked={item.is_attendance_required === 'optional'}
                className="disabledCursor"
                disabled={true}
              />
            </div>
          </td>
          <td className="text-center">
            <InputSwitch
              className="disabledCursor"
              id={'send_reminder'}
              value={item.send_reminder}
              checked={item.send_reminder}
              placeholder="Meeting URL"
              disabled={true}
            />
          </td>
        </tbody>
      );
    });
  };
  return (
    <>
      {Boolean(selectedGroups?.length) && (
        <div className="d-flex align-items-center py-2">
          <div className="col-12">
            <table className="table attendees-table">
              <thead>
                <tr>
                  <th className="attendee-names text-muted">Groups</th>
                  <th className="text-center">
                    <label className="text-muted">Required</label>
                  </th>
                  <th className="text-center">
                    <label className="text-muted">Optional</label>
                  </th>
                  <th className="text-center">
                    <label className="text-muted">Send Reminder</label>
                  </th>
                </tr>
              </thead>
              {dataPreview(selectedGroups, 'groups')}
            </table>
          </div>
        </div>
      )}
      {Boolean(selectedFirmUsers?.length) && (
        <div className="d-flex align-items-center py-2">
          <div className="col-12">
            <table className="table attendees-table">
              <thead>
                <tr>
                  <th className="attendee-names text-muted">Firm Users</th>
                  <th className="text-center">
                    <label className="text-muted">Required</label>
                  </th>
                  <th className="text-center">
                    <label className="text-muted">Optional</label>
                  </th>
                  <th className="text-center">
                    <label className="text-muted">Send Reminder</label>
                  </th>
                </tr>
              </thead>
              {dataPreview(selectedFirmUsers, 'firm_users')}
            </table>
          </div>
        </div>
      )}
      {Boolean(selectedContacts?.length) && (
        <div className="d-flex align-items-center py-2">
          <div className="col-12">
            <table className="table attendees-table">
              <thead>
                <tr>
                  <th className="attendee-names text-muted">Contacts</th>
                  <th className="text-center">
                    <label className="text-muted">Required</label>
                  </th>
                  <th className="text-center">
                    <label className="text-muted">Optional</label>
                  </th>
                  <th className="text-center">
                    <label className="text-muted">Send Reminder</label>
                  </th>
                </tr>
              </thead>
              {dataPreview(selectedContacts, 'contacts')}
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default AttendeesPreview;
